import { bl_svc_doc_attachment_RowClass } from '../../../dbschema/bl_svc_doc_attachment.model';
import { BaseContainerModel } from '../../base-container.model';


export class ServiceDocAttchmentContainerModel extends BaseContainerModel {
  bl_svc_doc_attachment: bl_svc_doc_attachment_RowClass = new bl_svc_doc_attachment_RowClass();
}
